import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DialogRef } from '../dialog-ref';
import { DialogCloseable } from '@components/dialog/dialog-closeable';
import { TranslateModule } from '@ngx-translate/core';
import { ElementsModule } from '@shared/elements/elements.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FormValidationModule } from '@components/form-validation/form-validation.module';
import { DialogTitleComponent } from '../dialog-title.component';
import { DialogBodyComponent } from '../dialog-body.component';
import { DialogActionsComponent } from '../dialog-actions.component';
import { DialogCloseDirective } from '../dialog-close.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'pay-dialog-save-changes',
    templateUrl: './dialog-save-changes.component.html',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        ElementsModule,
        ReactiveFormsModule,
        FormValidationModule,
        DialogTitleComponent,
        DialogBodyComponent,
        DialogActionsComponent,
        DialogCloseDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./dialog-save-changes.component.scss'],
    host: {
        'class': 'c-dialog active c-dialog--sm c-dialog--gutter-xlg',
        '[class.c-dialog--icon]': 'config.icon && config.icon.length > 0'
    }
})
export class DialogSaveChangesComponent implements DialogCloseable {
    public config;
    public okButtonTitle: string;
    public isClosing: boolean = false;

    constructor(public dialogRef: DialogRef<DialogSaveChangesComponent>,
                public cdr: ChangeDetectorRef) {
        this.config = dialogRef.containerInstance.config;
        this.okButtonTitle = this.config.okButtonTitle || 'Common.SaveChanges.YesSave';
    }

    /**
     * Process confirmed request and close.
     */
    process() {
        let result: boolean = true;
        this.isClosing = true;
        this.cdr.detectChanges();

        if (this.config.process) {
            // if the process returns a promise store it, else simply close it using `true`
            result = this.config.process() || true;
        }

        this.dialogRef.close(result);
    }

    /**
     * Updates the closing status.
     */
    onClose() {
        this.isClosing = true;
        this.cdr.detectChanges();
    }
}
